import { WALLET_ERRORS } from '../constants/api'
import { formatValidator } from './validation.helpers'

const isWalletConnected = ({
  mounted,
  authenticationStatus,
  account,
  chain
}) => {
  const ready = mounted && authenticationStatus !== 'loading'
  return (
    ready &&
    account &&
    chain &&
    (!authenticationStatus || authenticationStatus === 'authenticated')
  )
}

const WALLET_ACCOUNT_STATUS = {
  CONNECTED: 'connected'
}

const buildTransactionErrorMessage = (message) => {
  return formatValidator(
    message === WALLET_ERRORS.USER_REJECTED_REQUEST
      ? 'home.rejected-transaction-request'
      : message || 'home.something-went-wrong'
  )
}

const checkWalletConnected = ({ address, status }) => {
  return (
    status === WALLET_ACCOUNT_STATUS.CONNECTED &&
    address &&
    (process.env.REACT_APP_COMPROMISED_WALLET_CHECK === 'true' ||
      address.toLowerCase() !== '0x5aec08955b66c713273cfc6a9283515f1f703d3e')
  )
}

export {
  WALLET_ACCOUNT_STATUS,
  buildTransactionErrorMessage,
  checkWalletConnected,
  isWalletConnected
}
